import React, { useEffect, useState, Fragment } from 'react'
import clsx from 'clsx'
import styled from 'styled-components'
import {
  withStyles,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  ButtonBase,
  Button,
  Modal,
  Backdrop,
  Fade,
  TextField,
  InputAdornment,
  Drawer,
  Divider,
  Checkbox,
  FormControl,
  FormControlLabel,  
  Snackbar,
  SnackbarContent,
  TablePagination,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Tooltip,
} from '@material-ui/core'
import {MarkunreadMailbox, ExpandMore, ViewAgendaOutlined, ErrorOutline} from '@material-ui/icons/'
import {BiSearch} from 'react-icons/bi'
import {VscExpandAll, VscCollapseAll} from 'react-icons/vsc'
import Cookies from 'js-cookie'
import moment from 'moment'
import DayPicker from '../calendar/DayPicker'
import noImage from '../../assets/noImage.png'
import EventRoiDrawer from '../eventMarketing/EventRoiDrawer'
import PageHeader from '../PageHeader'
import AskReport from '../AskReport'

const date_format = "YYYY-MM-DD"

const StyledTextField = styled(TextField)`
  label.Mui-focused {
    color: #25aae1;
    margin-left: 10px;
  }
  .MuiOutlinedInput-root {
    fieldset {
      border-color: #fff;
      color: #fff;
      height: 45px;
      border-radius: 8px;
    }
    &.label {
      color: #fff;      
    }    
    &.Mui-focused fieldset {
      border-color: #25aae1;
    }    
  }
  .MuiOutlinedInput-input {
    color: #fff;
    margin-top: 3px;    
  }
`

const StyledTextFieldLT = styled(TextField)`
  label.Mui-focused {
    color: #25aae1;
    margin-left: 10px;
  }
  .MuiOutlinedInput-root {
    fieldset {
      border-color: #6e6e6e;
      color: #6e6e6e;
      height: 45px;
      border-radius: 8px;
    }
    &.label {
      color: #6e6e6e;      
    }    
    &.Mui-focused fieldset {
      border-color: #25aae1;
    }    
  }
  .MuiOutlinedInput-input {
    color: #6e6e6e;
    margin-top: 3px;    
  }
`

const StyledAccordion = styled(Accordion)(({theme}) => ({  
  '&:before': {
    display: "none"
  }
}))

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    fontSize: "11px",
    fontWeigth: "bold",
  }
}))(Tooltip)

const CustomCheckbox = withStyles({
  root: {
      '&$checked': {
          color: "#25aae1",          
      },
  },
  checked: {},
})(props => <Checkbox color="default" {...props} />)

const EventMarketing = (props) => {    
  const { secondaryOpen, dateExtended, openJob, secondaryTab, dark } = props  
  const token = Cookies.get("token")
  const currentUser = JSON.parse(localStorage.getItem("currentUser"))[0] ?  JSON.parse(localStorage.getItem("currentUser"))[0] : {}
  const initialStartDate = currentUser.max_date_event && currentUser.max_date_event !== "" ? moment(currentUser.max_date_event).startOf("year").subtract(1, "years") : moment().startOf("year").subtract(1, "years")
  const initialEndDate = currentUser.max_date_event && currentUser.max_date_event !== "" ? moment(currentUser.max_date_event) : moment()
  const [eventData, setEventData] = useState(null)
  const [days, setDays] = useState(0)
  const [dataType, setDataType] = useState(dateExtended ? dateExtended : "Data_Extended")
  const [page, setPage] = useState(0)  
  const [searchTerm, setSearchTerm] = useState("")
  const [openModal, setOpenModal] = useState(false)
  const [modalImg, setModalImg] = useState(null)
  const [openRoi, setOpenRoi] = useState(false)
  const [openSecondaryRoi, setOpenSecondaryRoi] = useState(false)
  const [roiData, setRoiData] = useState(null)
  const [secondaryRoiData, setSecondaryRoiData] = useState(null)
  const [marketData, setMarketData] = useState(null)
  const [job, setJob] = useState(null)
  const [expandedPanels, setExpandedPanels] = useState(null)
  const [minYearmo, setMinYearmo] = useState(JSON.parse(localStorage.getItem("currentUser"))[0].max_date_event ? moment(JSON.parse(localStorage.getItem('currentUser'))[0].max_date_event).startOf('year').subtract(1, 'years') : moment().startOf('year').subtract(1, 'years'))
  const [maxYearmo, setMaxYearmo] = useState(JSON.parse(localStorage.getItem("currentUser"))[0].max_date_event ? moment(JSON.parse(localStorage.getItem("currentUser"))[0].max_date_event) : moment())
  const [restoreHidden, setRestoreHidden] = useState(true)
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [checkedPromos, setCheckedPromos] = useState([])
  const [comparePromosCount, setComparePromosCount] = useState(0)
  const [checkedPromosTotal, setCheckedPromosTotal] = useState(null)
  const [promosToAdd, setPromosToAdd] = useState([])

  const metrics = !secondaryOpen ? [
    {name: "SPEND", color: "#ff7373", attr: "Cost"},
    {name: "MAILED", color: "#c58fff", attr: "Mailed"},
    {name: "RESPONSES", color: "#4ed4fc", attr: "Responses"},
    {name: "SALES", color: "#92e635", attr: "Sales"},
    {name: "RESPONSE RATE", color: "#ff8ffe", attr: "Res_Rate"},
    {name: "AVG TICKET", color: "#f0e043", attr: "Avg_Ticket"},
  ] : [    
    {name: "MAILED", color: "#c58fff", attr: "Mailed"},    
    {name: "SALES", color: "#92e635", attr: "Sales"},
    {name: "RESPONSE RATE", color: "#ff8ffe", attr: "Res_Rate"},    
  ]

  const getEventData = () => {
    const request = fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/tentpoleROI/jobID?startDate=${initialStartDate.format(date_format)}&endDate=${initialEndDate.format(date_format)}`, {
      headers: {
        token: token
      }
    })

    request.then(response => response.json())
    .then(data => {
      if(data.length > 0) {
        setEventData(data.reverse())
        setDays(initialEndDate.diff(initialStartDate, "days"))
        
        let expandedObj = {}
        for(let i = 0; i < data.length; i++) {                
          expandedObj[`panel${data[i].Key}`] = false      
        }      
        setExpandedPanels(expandedObj)      
      } else {
        setEventData([])
        setDays(initialEndDate.diff(initialStartDate, "days"))
        setExpandedPanels({})
      }
    })
    .catch(error => {console.log(error)})
  }

  useEffect(() => getEventData(), [])

  const handleChangePage = (e, newPage) => {
    let obj = {...expandedPanels}
    for (const key in obj) {
      obj[key] = false
    }

    setExpandedPanels(obj)
    setPage(newPage)
  }

  const updateSearch = (e) => {
    const { value } = e.target

    if(value) setSearchTerm(value.substr(0,25))
    else setSearchTerm("")
  }

  const handleDataTypeChange = (e) => {
    const { value } = e.target
    setDataType(value)
  }

  const handleOpenCreative = (e) => {
    e.stopPropagation()
    const { src } = e.target    
    
    setOpenModal(true)
    setModalImg(src)    
  }

  const handleCloseCreative = () => {
    setOpenModal(false)
    setModalImg(null)
  }

  const handleOpenRoiDrawer = (e, job) => {    
      e.stopPropagation()
      setRoiData(eventData.filter(({JobID}) => JobID === job))
      setOpenRoi(true)
      setJob(job)        
  }

  const handleDrawerClose = () => {
    setOpenRoi(false)
    setJob(null)
  }

  const handleChangeDateRange = (value, valName) => {    
    if(valName === "startDate") {                  
      const request = fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/tentpoleROI/jobID?startDate=${value.format(date_format)}&endDate=${maxYearmo.format(date_format)}`, {
        headers: {
          token: token
        }
      })

      request.then(response => response.json())
      .then(data => {                        
        if(data.length > 0) {
          setEventData(data.reverse())
          setDays(maxYearmo.diff(value, "days"))
          setMinYearmo(value)
          setRestoreHidden(false)
          setPage(0)
        } else {
          setSnackbarOpen(true)
          setErrorMessage("There are no promotions within the selected range. Please broaden the filters and try again.")
        }
      })
      .catch(error => {console.log(error)})
    } else {          
      const request = fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/tentpoleROI/jobID?startDate=${minYearmo.format(date_format)}&endDate=${value.format(date_format)}`, {
        headers: {
          token: token
        }
      })

      request.then(response => response.json())
      .then(data => {        
        if(data.length > 0) {
          console.log(data)
          setEventData(data.reverse())
          setDays(value.diff(minYearmo, "days"))
          setMaxYearmo(value)
          setRestoreHidden(false)
          setPage(0)
        } else {          
          setSnackbarOpen(true)
          setErrorMessage("There are no promotions within the selected range. Please broaden the filters and try again.")
        }
      })
    }  
  }

  const handleSliderDateChange = (values) => {
    const startDate = values[0]
    const endDate = values[1]

    const request = fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/tentpoleROI/jobID?startDate=${startDate}&endDate=${endDate}`, {
      headers: {
        token: token
      }
    })

    request.then(response => response.json())
    .then(data => {
      if(data) {
        setEventData(data.reverse())
        setRestoreHidden(false)
      } else {
        setSnackbarOpen(true)
        setErrorMessage("There are no promotions within the selected range. Please broaden the filters and try again.")
      }
    })
    .catch(error => {console.log(error)})
  }

  const handleDateClear = () => {
    const request = fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/tentpoleROI/jobID?startDate=${initialStartDate.format(date_format)}&endDate=${initialEndDate.format(date_format)}`, {
      headers: {
        token: token
      }
    })

    request.then(response => response.json())
    .then(data => {
      setEventData(data.reverse())
      setMinYearmo(initialStartDate)
      setMaxYearmo(initialEndDate)
      setDays(initialEndDate.diff(initialStartDate, "days"))
      setRestoreHidden(true)
    })
  }

  const handleExpandPanel = (e, key) => {            
    setExpandedPanels(prevState => ({...prevState, [`panel${key}`]: !prevState[`panel${key}`]}))
  }

  const handleSnackbarClose = (e, reason) => {
    if(reason === "clickaway") {
      setSnackbarOpen(false)
    }
    setSnackbarOpen(false)
  }

  const toggleExpandAll = (expandType) => {    
    let obj = {...expandedPanels}

    for(const key in obj) {
      obj[key] = expandType
    }

    setExpandedPanels(obj)
  }

  const handleCheck = (e, jobID) => {
    let comparePanels = [...promosToAdd]
    let currentIdx = comparePanels.map(({JobID}) => JobID).indexOf(jobID)
    setCheckedPromos(checkedPromos.includes(jobID) ? checkedPromos.filter(c => c !== jobID) : [...checkedPromos, jobID])    

    if(currentIdx === -1) comparePanels.push(eventData.filter(({JobID}) => JobID === jobID)[0])
    else comparePanels.splice(currentIdx, 1)

    setPromosToAdd(comparePanels)

    console.log(comparePanels)

    let total = comparePanels.map(item => item[`${dataType}`][0]).reduce((a,b) => {
      for(const prop in b) {
        if(a.hasOwnProperty(prop)) a[prop] += b[prop]
        else a[prop] = b[prop]
      }
      return a
    }, {})

    total["Res_Rate"] = total["Mailed"] > 0 ? total["Responses"] / total["Mailed"] : 0
    total["Avg_Ticket"] = total["Responses"] > 0 ? total["Sales"] /total["Responses"] : 0

    setCheckedPromosTotal(total)
  }

  const handleCompare = () => {    
    const comparePromos = []

    if(checkedPromos.length >= 2) {
      for(let i = 0; i < checkedPromos.length; i++) {
        comparePromos.push(eventData.filter(({JobID}) => JobID === checkedPromos[i])[0])
      }    

      console.log(comparePromos)
    
      setPage(0)
      setEventData(comparePromos)
      setComparePromosCount(comparePromos.length)
      toggleExpandAll(true)
    }
  }
  
  const resetCompare = () => {            
    const request = fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/tentpoleROI/jobID?startDate=${minYearmo.format(date_format)}&endDate=${maxYearmo.format(date_format)}`, {
      headers: {
        token: token
      }
    })

    request.then(response => response.json())
    .then(data => {      
      setEventData(data.reverse())
      setComparePromosCount(0)
      setCheckedPromos([])
      toggleExpandAll(false)
    })
    .catch(error => {console.log(error)})
  }

  if(!eventData || !expandedPanels) return <CircularProgress />
  if(eventData.length < 1) return <AskReport />

  const roiDrawer = (
    <Drawer
      anchor="right"      
      variant={secondaryOpen ? "persistent" : "temporary"}
      hideBackdrop={true}
      elevation={0}
      open={openRoi}      
      PaperProps={{
        style: {
          width: `${secondaryOpen ? "50%" : "100%"}`,          
          background: "#575757"
        }
      }}
    >          
      <EventRoiDrawer
        handleDrawerClose={handleDrawerClose}
        jobID={job}        
        data={roiData}        
        dataType={dataType}
        secondaryOpen={secondaryOpen}
        secondaryTab={secondaryTab}
        darkMode={dark}
      />      
    </Drawer>
  )

  const snackbar = () => (
    <Snackbar
      open={snackbarOpen}
      autoHideDuration={4500}
      onClose={handleSnackbarClose}
      anchorOrigin={{vertical: "top", horizontal: "center"}}
    >
      <SnackbarContent 
        message={errorMessage}
        style={{color: "#fff", backgroundColor: "#ff9800"}}
      />
    </Snackbar>
  )
    
  const renderAccordion = (data) => {    

    return (
      data.slice(page * 10, page * 10 + 10)
      .map(({JobID, Promotion, Creative, Key, Complete}, i) => (
          <StyledAccordion 
            className={`accordion ${dark ? "bg-dk" : "bg-lt"}`} 
            key={Key} 
            onClick={(e) => handleExpandPanel(e, Key)}
            expanded={expandedPanels[`panel${Key}`]}
          >        
            <AccordionSummary className="summary" expandIcon={<ExpandMore style={{color: `${dark ? "#fff" : "#6e6e6e"}`}}/>}>
              <FormControlLabel
                name={JobID}
                control={<CustomCheckbox disableRipple size="small"/>}
                checked={checkedPromos.indexOf(JobID) !== -1}
                onClick={e => e.stopPropagation()}
                onChange={e => handleCheck(e, JobID)}
              />
              <div className="heading-columns">
                <Typography className={`heading ${dark ? "content-dk" : "content-lt"}`}>
                  {Promotion}
                  <span>
                    {Complete == 0 ?
                      <CustomTooltip
                        title={`NOTE: Results for this promotion are incomplete at this time, Complete results will be available after the end of the promotion on ${moment(data.filter(item => item.Key === Key)[0][dataType[0].MaxWrittenDate]).format("MM/DD/YYYY")}`}
                        style={{fontSize: "25px"}}
                      >
                        <ErrorOutline style={{fontSize: "15px", color: "#ff9670", marginLeft: "10px"}}/>
                      </CustomTooltip>
                    : null}
                  </span>
                </Typography>
                <Typography className="sub">Job: {JobID}</Typography>              
              </div>
              <div className="flex-grow" />            
              <div className={`preview-details ${dark ? "content-dk" : "content-lt"}`}>
                <Typography variant="caption">PROMO DATES:                              
                  {` ${moment(data.filter(item => item.Key === Key)[0][dataType][0].PromoStartDate).format("MMM DD, YYYY").toUpperCase()} - ${moment(data.filter(item => item.Key === Key)[0][dataType][0].PromoEndDate).format("MMM DD, YYYY").toUpperCase()}`}
                </Typography>              
                {!expandedPanels[`panel${Key}`] ?
                  <Fragment>
                    <Divider orientation="vertical" style={{height: "10px", margin: "5px 15px 0px 15px", backgroundColor: `${dark ? "#fff" : "#6e6e6e"}`}}/>
                    <Typography variant="caption">MAILED:
                      {(data.filter(item => item.Key === Key)[0][dataType][0].Mailed).toLocaleString("en")}
                    </Typography>              
                    <Divider orientation="vertical" style={{height: "10px", margin: "5px 15px 0px 15px", backgroundColor: `${dark ? "#fff" : "#6e6e6e"}`}}/>
                    <Typography variant="caption">RESPONSE RATE:
                      {(data.filter(item => item.Key === Key)[0][dataType][0].Res_Rate * 100).toFixed(2)}%
                    </Typography>
                  </Fragment>
                :
                  null
                }
              </div>
            </AccordionSummary>
            <AccordionDetails className="accordion-details">
              {Object.keys(Creative).length > 0 ? 
              <Fragment>
                <ButtonBase                                    
                    onClick={handleOpenCreative}
                >
                  {Creative["One"] ?
                    <img src={Creative["One"]} alt="" style={{width: "150px", borderRadius: "8px"}}/>
                  :
                    <img src={noImage} alt="" style={{width: "150px", borderRadius: "8px"}}/>
                  }
                </ButtonBase>
                <ButtonBase                                    
                  onClick={handleOpenCreative}
                  style={{marginLeft: "10px"}}
                >
                  {Creative["Two"] ?
                    <img src={Creative["Two"]} alt="" style={{width: "150px", borderRadius: "8px"}}/>
                  :
                    <img src={noImage} alt="" style={{width: "150px", borderRadius: "8px"}}/>
                  }
                </ButtonBase>
              </Fragment>
                // Object.keys(Creative).filter(key => key === "One" || key === "Two").map((key, i) => (
                //   <ButtonBase
                //       key={`${JobID}-${key}`}
                //       style={key === "Two" ? {marginLeft: "10px"} : {}}
                //       onClick={handleOpenCreative}
                //   >                
                //     {Creative[key] ?
                //       <img src={Creative[key]} alt="" style={{width: "150px", borderRadius: "8px"}}/>
                //     :
                //       <img src={noImage} alt="" style={{width: "150px", borderRadius: "8px"}}/>
                //     }
                //   </ButtonBase>
                // ))
              :
                [...Array(2)].map((item, i) => (
                  <ButtonBase key={`${JobID}-${i}`} style={i === 1 ? {marginLeft: "10px"} : {}}>
                    <img src={noImage} style={{width: "150px", borderRadius: "8px"}}/>
                  </ButtonBase>
                ))
              }           
  
              <div className="stats">              
                <div className="metrics">
                  {metrics.map(({name, color, attr}, j) => (
                    <Fragment key={`${name}-${j}`}>
                      <Typography style={{color: `${dark ? "#fff" : "#6e6e6e"}`}} className="metric-label">
                        <span style={{color: `${color}`, marginTop: "10px", fontWeight: "bold"}}>{name}:</span><br/>
                        <span className="metric">{attr === "Cost" || attr === "Sales" || attr === "Avg_Ticket" ? "$" : null}</span>
                        <span className="metric">
                          {
                            attr !== "Res_Rate" && attr !== "Avg_Ticket" ? 
                            Math.round(data.filter(item => item.Key === Key)[0][dataType][0][attr]).toLocaleString("en")
                          : attr === "Avg_Ticket" ?
                             Math.round(data.filter(item => item.Key === Key)[0][dataType][0]["Sales"] / data.filter(item => item.Key === Key)[0][dataType][0]["Responses"]).toLocaleString("en")
                          :
                            (data.filter(item => item.Key === Key)[0][dataType][0][attr] * 100).toFixed(2)
                          }
                        </span>
                        <span>{attr === "Res_Rate" ? "%" : null}</span>
                      </Typography>
                    </Fragment>
                  ))}
                </div>
                <div className="event-roi-btn">             
                  <Typography onClick={(e) => handleOpenRoiDrawer(e, JobID)}>VIEW ROI</Typography>
                </div>
              </div>
            </AccordionDetails>
          </StyledAccordion>
        ))    
    )  
  }
  
  let filteredData = eventData.filter(({Data_Extended, Data_Promo, Promotion, JobID}) => {
    return Data_Extended.length > 0 && Data_Promo.length > 0 && JobID !== openJob ? Promotion.replace(/'/g, '').toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1 || JobID.indexOf(searchTerm) !== -1 : ""
  })

  return (
    <div id="event-marketing">
      {!secondaryOpen ? 
        <Fragment>
          <PageHeader details={{icon: <MarkunreadMailbox style={{fontSize: "15px"}}/>, title: "EVENT MARKETING - DIRECT MAIL"}} />
          <br/>
        </Fragment>
      :
        null
      }
      {snackbar()}
      <div className="filters">
        <div>
          {dark ? 
            <StyledTextField
              variant="outlined"
              label={<Typography style={{color: `${dark ? "#fff" : "#6e6e6e"}`, marginTop: "-2px"}}>Search By Event</Typography>}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <BiSearch style={{color: `${dark ? "#fff" : "#6e6e6e"}`}} fontSize="small" />
                  </InputAdornment>
                )
              }}
              value={searchTerm}
              onChange={updateSearch}
              style={{color: `${dark ? "#fff" : "#6e6e6e"}`}}
              size="small"
              className="search-bar"
            />
          :
            <StyledTextFieldLT
              variant="outlined"
              label={<Typography style={{color: `${dark ? "#fff" : "#6e6e6e"}`, marginTop: "-2px"}}>Search By Event</Typography>}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <BiSearch style={{color: `${dark ? "#fff" : "#6e6e6e"}`}} fontSize="small" />
                  </InputAdornment>
                )
              }}
              value={searchTerm}
              onChange={updateSearch}
              style={{color: `${dark ? "#fff" : "#6e6e6e"}`}}
              size="small"
              className="search-bar"
            />
          }
          {!secondaryOpen ? 
            <FormControl size="small">
              <Select
                value={dataType}
                variant="outlined"
                inputProps={{
                  name: "date",
                  style: {color: `${dark ? "#fff" : "#6e6e6e"}`}
                }}
                onChange={handleDataTypeChange}
                style={{border: `1px solid ${dark ? "#fff" : "#6e6e6e"}`, color: `${dark ? "#fff" : "#6e6e6e"}`, marginLeft: "10px", borderRadius: "8px"}}
                size="small"
              >
                <MenuItem value={"Data_Extended"}>Extended Date</MenuItem>
                <MenuItem value={"Data_Promo"}>Promo Date</MenuItem>
              </Select>
            </FormControl>
          :
              null
          }
        </div>        
          <div className={!secondaryOpen ? "date-slider" : "date-slider-half"}>
            <DayPicker
              startDate={minYearmo}
              endDate={maxYearmo}
              maxSliderValue={days}
              maxDate={'event'}
              handleDateRange={handleChangeDateRange}
              handleSliderDateChange={handleSliderDateChange}
              handleDateClear={handleDateClear}
              restoreHidden={restoreHidden}
              dark={dark}
            />          
          <div className="expand-btn-group">
            <Button
              className="expand-btn"
              size="small"
              endIcon={<ViewAgendaOutlined />}
              disableRipple
              style={{marginRight: "10px"}}
              onClick={handleCompare}
            >
              <Typography variant="caption">COMPARE</Typography>
            </Button>
            <Button
              className="expand-btn"
              size="small"
              endIcon={<ViewAgendaOutlined />}
              disableRipple
              style={{marginRight: "10px"}}
              onClick={resetCompare}
            >
              <Typography variant="caption">RESET COMPARE</Typography>
            </Button>            
            <Button
              className="expand-btn"                
              onClick={() => toggleExpandAll(true)}
              size="small"
              endIcon={<VscExpandAll />}
              disableRipple
              style={{marginRight: "10px"}}
            >
              <Typography variant="caption">EXPAND ALL</Typography>
            </Button>
            <Button
              className="expand-btn"                
              onClick={() => toggleExpandAll(false)}
              size="small"
              endIcon={<VscCollapseAll />}
              disableRipple
            >
              <Typography variant="caption">COLLAPSE ALL</Typography>
            </Button>            
          </div>
        </div>
      </div>
      <br/>          
      <Modal
        open={openModal}
        onClose={handleCloseCreative}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{timeout:500}}
        className="event-modal"
      >
        <Fade in={openModal}>        
          <img className="img" src={modalImg} alt="" />
        </Fade>
      </Modal>      
      {renderAccordion(filteredData, secondaryOpen)}
      {comparePromosCount >= 2 && checkedPromos.length >= 2 ?        
        <Accordion className={`accordion ${dark ? "bg-dk" : "bg-lt"}`} expanded={true}>          
          <AccordionDetails className="accordion-details">
            <Typography className="heading" style={{width: "400px", marginTop: "10px", fontWeight: "bold"}}>PROMOTIONS TOTALS</Typography>            
            <div className="stats" style={{border: "none"}}>
              <div className="metrics">
                {metrics.map(({name, color, attr}, i) => (
                  <Fragment key={i}>
                    <Typography style={{color: `${dark ? "#fff" : "#6e6e6e"}`}} className="metric-label">
                      <span style={{color: `${color}`, marginTop: "10px", fontWeight: "bold"}}>{name}:</span><br/>
                      <span className="metric">{attr === "Cost" || attr === "Sales" || attr === "Avg_Ticket" ? "$" : null}</span>
                      <span className="metric">                        
                        {attr !== "Res_Rate" ?
                          Math.round(checkedPromosTotal[attr]).toLocaleString("en")
                        :
                          (checkedPromosTotal[attr] * 100).toFixed(2)
                        }
                      </span>
                      <span>{attr === "Res_Rate" ? "%" : null}</span>
                    </Typography>
                  </Fragment>
                ))}
              </div>
            </div>
          </AccordionDetails>
        </Accordion>        
      :
        null
      }      
      {roiDrawer}
      {filteredData.length > 10 ?
        <TablePagination
          rowsPerPageOptions={[]}
          component="div"
          count={filteredData.length}
          rowsPerPage={10}
          page={page}
          onChangePage={handleChangePage}
          style={{color: `${dark ? "#fff" : "#6e6e6e"}`}}
        />
      :null
      }
    </div>
  )
}

export default EventMarketing
